export const formatDate = (isoDate: string) => {
  const date = new Date(isoDate);
  return `${date.toLocaleDateString('de-DE')}, ${date.toLocaleTimeString('de-DE')} Uhr`;
};
